import { createStore } from "vuex";

// import auth from './modules/auth.js';
// const store = createStore({
//     modules: {
//         auth
//     }
// })

const store = createStore({
  modules: {},
});

// Automatically register all modules from the modules/ directory
const modulesContext = import.meta.glob("./modules/*.js", { eager: true });

Object.keys(modulesContext).forEach((key) =>
{
  const moduleName = key.match(/([a-z_]+)\.js$/i)[1];
  const moduleConfig = modulesContext[key].default;
  store.registerModule(moduleName, moduleConfig);
});

export default store;

// const modules = requireContext.keys()
//     .map(file =>
//         [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
//     )
//     .reduce((modules, [name, module]) => {
//         if (module.namespaced === undefined) {
//             module.namespaced = true
//         }

//         return { ...modules, [name]: module }
//     }, {})
// store.js
